import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={SITE.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform whatsapp-pulse"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
